<template>
  <v-dialog
    v-if="show_contract"
    v-model="show_contract"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-toolbar dark color="primary" class="toolbar">
        <v-btn icon dark @click="$emit('hide')">
          <v-icon v-once>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn light @click="printContract()">Imprimir</v-btn>
      </v-toolbar>
    <v-card style="max-height:100%; height:100%;">
      
      <div style="position: relative; max-height:7.5%; height:7.5%;"></div>
      <div class="pa-12" style=" max-height:92.5%; height:92.5%; overflow-y:scroll;">
        <slot>
          <a href="https://wordtohtml.net/">https://wordtohtml.net/</a>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum,
          ratione laboriosam accusantium quaerat earum asperiores ut, nemo
          facere molestiae est maxime. Eius voluptate iste cumque a nihil
          laboriosam nobis deserunt?
        </slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "DialogLink",
  props: {
    name: String,
    show_contract: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({
        printContract: "dialog_contract/printContract",
    }),
  }
};
</script>
<style scoped>
  .toolbar {
    position: fixed;
    width: 100%;
    max-height:100px; 
    height:100px;
    z-index: 99;
  }

  @media print {
    header.toolbar {
      display: none;
    }
    
    div[role="menu"] {
      display: none!important;
    }
    div.v-application--wrap {
      display: none !important;
    }

    div[role="document"] > div.v-dialog > div.v-card > div:nth-child(1) {
      display: none !important;
    }

    div[role="document"] {
      position: static !important;
    }

    div[role="document"] > div.v-dialog {
      position: static !important;
       box-shadow: none !important;
    }

    div[role="document"] > div.v-dialog > div.v-card {
      position: static !important;
      box-shadow: none !important;
    }

    div[role="document"] > div.v-dialog > div.v-card > div:nth-child(2) {
      position: static !important;
    }
    
    div.v-application--wrap {
      display: none !important;
    }
    
    ::-webkit-scrollbar {
        display: none;
    }
  }
   
</style>